import _ from 'lodash';

export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];

    return reducer
      ? reducer(state, action.payload, action.meta)
      : state;
  };
}

export function buildActionCreator(actionType, actionCreatorWithoutType) {
  const prefixedActionType = `@TAF_UI/${actionType}`;

  const actionCreator = (...args) =>
    ({
      type: prefixedActionType,
      ...!_.isUndefined(actionCreatorWithoutType) &&
      actionCreatorWithoutType(...args),
    });

  actionCreator.toString = () => prefixedActionType;
  return actionCreator;
}
